import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { ALL_USERS } from '../get-all-users';
import { updateUserAPI } from './api';

export function useUpdateUser({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal, isModalOpen } = useModal();
  const isConfirmationModalOpen = isModalOpen('ConfirmationModal');

  const { mutate, isLoading, isSuccess, isError } = useMutation(
    ({ userId, userData }) => updateUserAPI(userId, userData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        if (!isConfirmationModalOpen) {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'success',
              description: 'updateUserSuccess',
            },
          });
        }
        if (onSuccess) {
          onSuccess();
        }

      },
    },
  );

  return {
    updateUser: mutate,
    isLoading,
    isSuccess,
    isError,
  };
}
